import React from 'react'
import { Link } from 'react-router-dom'
import { withTranslation } from 'react-i18next'

const WhatIsBlock = ({ t }) => {
    return (
        <div className="home__what-is-block">
            <div className="box">
                {/*<div className="play-button"></div>*/}
                <h3>{t('_pages._home._what_is_block.title')}</h3>
                <article>
                    {t('_pages._home._what_is_block.article')}{' '}
                    <Link to="/how-it-works">{t('_pages._home._what_is_block.article-link')}</Link>
                    {/* <a href="#">{t('_common.read_more')}</a>*/}
                </article>
            </div>
        </div>
    )
}

export default withTranslation('translations')(WhatIsBlock)
